import React from 'react';
import { Pagination } from 'antd';

interface PaginationComponentProps {
  currentPage: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number, size: number) => void;
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({
  currentPage,
  total,
  pageSize,
  onPageChange,
}) => {
  const handlePageChange = (page: number, size: number) => {
    onPageChange(page, size);
  };

  return (
    <div className="mt-3">
      <Pagination
        className="cursor-pointer"
        showSizeChanger
        onChange={handlePageChange}
        onShowSizeChange={handlePageChange}
        current={currentPage}
        total={total}
        pageSize={pageSize}
      />
    </div>
  );
};

export default PaginationComponent;
